import 'jquery-validation';
import {ScrollTrigger} from 'gsap/ScrollTrigger';

import CustomAnimation from "src/scripts/animation/customAnimation";
import {gsap} from "gsap";


const customAnmation = new CustomAnimation();


class Register {
  constructor() {
  }

  init() {
    this.initPage();
    this.initParallax();
  }

  initPage = () => {
  }

  initParallax = () => {
    gsap.registerPlugin(ScrollTrigger);

    customAnmation.animateHeaderImage('.header');
    customAnmation.animateFromBottom('.form-group');
    customAnmation.animateButtonGroup('.button');

  }
}

export default Register;
